import { useEffect } from "react";

import { useTranslation } from "react-i18next";

import DropOffPlannerView from "../../components/dropOffPlanner/DropOffPlannerView";
import { usePageNameContext } from "../../contexts/PageTitleContext";

export default function DropOff() {
  const { t } = useTranslation("leads");
  const { setInfo } = usePageNameContext();

  useEffect(() => {
    setInfo({
      name: t("Drop Off Leads"),
      desc: t("Book drop off leads across the coming days"),
    });
  }, [setInfo, t]);

  return <DropOffPlannerView />;
}
